<div class="sidebar-container">
        <div class="sidebar-header">
            <div class="sidebar-header-row">
                <h2 class="sidebar-title">Tenants</h2>
                <button mat-icon-button class="add-tenant-button"
                matTooltip="Add New Tenant"
                (click)="openAddTenantDialog()"
                [disabled]="tenantContext.isLoading()"
                ><mat-icon>add</mat-icon></button>
            </div>
            
            <div class="filter-badges-row">
                <button mat-button class="filter-badge" 
                    [class.active]="statusFilter() === 'all'"
                    (click)="setStatusFilter('all')"
                    [disabled]="tenantContext.isLoading()">
                    <span class="badge-label">Total: {{tenantCounts().total}}</span>
                </button>
                <button mat-button class="filter-badge" 
                    [class.active]="statusFilter() === 'enabled'"
                    (click)="setStatusFilter('enabled')"
                    [disabled]="tenantContext.isLoading()">
                    <span class="badge-label">Enabled: {{tenantCounts().enabled}}</span>
                </button>
                <button mat-button class="filter-badge" 
                    [class.active]="statusFilter() === 'disabled'"
                    (click)="setStatusFilter('disabled')"
                    [disabled]="tenantContext.isLoading()">
                    <span class="badge-label">Disabled: {{tenantCounts().disabled}}</span>
                </button>
            </div>

            <div class="sidebar-search-row">
                <div class="search-bar-container">
                    <mat-form-field class="search-form-field">
                        <mat-label class="search-label"><mat-icon class="search-icon">search</mat-icon>Search</mat-label>
                        <input matInput class="search-input" value="" (input)="onSearchChanged($event)" #input/>
                        @if (input.value) {
                            <button matSuffix mat-icon-button (click)="removeSearch()">
                            <mat-icon>close</mat-icon>
                            </button>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>

        @if (tenantContext.isLoading() && this.tenantContext.tenantList().length == 0) {
            <div class="loading"><app-loading-spinner [strokeWidth]="5"></app-loading-spinner></div>
        }
        @else {
            <mat-nav-list mat-card-content class="sidebar-list" [disabled]="tenantContext.isLoading()">
                @if (filteredTenants().length > 0) {
                    @for (tenant of filteredTenants(); track tenant.tenantId) {
                        <mat-card class="tenant-item-card"
                            [class.active]="tenantContext.tenant()?.tenantId === tenant.tenantId"
                            [class.disabled]="tenantContext.isLoading()"
                            (click)="onTenantSelected(tenant)">
                            <div class="tenant-title-container">
                                @if (tenant.tenantAlias !== '' && tenant.tenantAlias !== null) {
                                    <mat-card-title class="tenant-title">{{tenant.tenantAlias}}</mat-card-title>
                                    <mat-card-title class="tenant-subtitle">{{tenant.tenantName}}</mat-card-title>
                                } @else {
                                    <mat-card-title class="tenant-title">{{tenant.tenantName}}</mat-card-title>
                                }
                                
                            </div>
                        </mat-card>
                    }
                } @else {
                    <div class="tenant-info-container">
                        <div class="icon-container">
                            <mat-icon>info</mat-icon>
                        </div>
                        <mat-card-title class="tenant-title" disabled>No tenants found</mat-card-title>
                    </div>
                }
            </mat-nav-list>
        } 
</div>